<template>
  <div v-if="checkComponent">
    <!-- footer section start -->
    <footer
      class="footer"
      :class="{
        'p-0 m-0': subfootershow,
        'only-sub-footer ': !customizationLocal.footer_main_availability,
        'd-none d-md-block': MenumobileFooter,
        'd-none d-sm-block': homeresponsiveFooter,
      }"
      id="footer-color"
    >
      <div class="container">
        <div
          class="row footer-main"
          v-if="customizationLocal.footer_main_availability"
          :class="{ 'd-none': subfootershow }"
        >
          <div class="col-lg-2 col-md-4">
            <BrandLogo></BrandLogo>
          </div>
          <Menu1></Menu1>
          <Menu2></Menu2>
          <Menu3 v-if="!domainBasedBrand"></Menu3>
          <Menu4 else></Menu4>
        </div>
        <footer-social />
        <SubFooter
          v-if="customizationLocal.footer_sub_availability"
        ></SubFooter>
      </div>
    </footer>
    <!-- footer section end -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BrandLogo from './brand_logo'
import Menu1 from './Menu1'
import Menu2 from './Menu2'
import Menu3 from './Menu3'
import Menu4 from './Menu4'
import FooterSocial from './FooterSocial'
import SubFooter from './Sub_Footer'
//import { log } from 'util'
export default {
  name: 'Footer',
  data() {
    return {
      mobilefooterHide: [
        'goorder_store_page',
        'goorder_store_page_category',
        'brand_store_page_category',
        'goorder_mobile_checkout',
        'brand_mobile_checkout',
        'profile.order-history',
        'brand_store_page',
        'brand_checkout',
        'store_checkout',
        'goorder_checkout',
        'goorder_cart',
        'brand_cart',
      ],
      subfooter: ['404'],
      mdfooterHide: ['home', 'faq', 'offers'],
      viewsList: [
        'login',
        'register',
        'forgot_password',
        'goorder_checkout',
        'brand_checkout',
        'goorder_cart',
        'brand_cart',
        'goorder_track-order',
        'brand_track-order',
        'profile.personal-info',
        'profile.ongoing-orders',
        'profile.scheduled-orders',
        'mobile_loyalty',
        'mobile_loyalty_usage',
        'mobile_wallet',
        'mobile_profile',
        'mobile-saved-cards',
        'help',
        'profile.saved-cards',
        'profile.notifications',
        'profile.addresses',
        'profile.history',
        'profile.wallet',
        'profile.order',
      ],
    }
  },
  computed: {
    ...mapGetters(['_T', 'domainBasedBrand', 'customizationLocal']),
    checkComponent() {
      if (
        this.$route.matched.some(({ name }) => this.viewsList.includes(name))
      ) {
        return false
      } else {
        return true
      }
    },
    MenumobileFooter() {
      if (
        this.$route.matched.some(({ name }) =>
          this.mobilefooterHide.includes(name)
        )
      ) {
        return true
      }
      return false
    },

    subfootershow() {
      if (
        this.$route.matched.some(({ name }) => this.subfooter.includes(name))
      ) {
        return true
      }
      return false
    },
    homeresponsiveFooter() {
      if (
        this.$route.matched.some(({ name }) => this.mdfooterHide.includes(name))
      ) {
        return true
      }
      return false
    },
  },
  components: {
    BrandLogo,
    Menu1,
    Menu2,
    Menu3,
    FooterSocial,
    SubFooter,
    Menu4,
  },
}
</script>

<style lang="scss">
.body-rtl {
  .sub-footer {
    ul {
      li {
        + li {
          border-right: $px1 solid rgba(237, 239, 244, 0.1);
          border-left: unset !important;
        }
      }
    }
  }
}
.footer {
  background-color: $color-footer;
  padding-top: calc(
    #{$px40} + (70 - 40) * ((100vw - #{$px320}) / (1920 - 320))
  );
  position: relative;
  z-index: 1;
  h5 {
    font-size: calc(
      #{$px16} + (18 - 16) * ((100vw - #{$px320}) / (1920 - 320))
    );
    line-height: $px22;
    letter-spacing: 0.7px;
    color: $white;
    font-weight: 600;
    margin: -$px4 0 $px15;
    span {
      display: none;
    }
  }
  .footer-main {
    ul {
      li {
        display: block;
        a {
          color: $white;
        }
        + li {
          padding-top: calc(
            #{$px10} + (20 - 10) * ((100vw - #{$px320}) / (1920 - 320))
          );
        }
      }
    }
    .footer-social {
      li {
        display: inline-block;
        + li {
          margin-left: $px16;
          padding-top: 0;
        }
        i {
          font-size: calc(
            #{$px20} + (30 - 20) * ((100vw - #{$px320}) / (1920 - 320))
          );
        }
      }
    }
  }
}
footer.only-sub-footer {
  padding-top: 0;
}
.sub-footer {
  margin-top: $px40;
  padding: $px35 0;
  border-top: 1px solid rgba(237, 239, 244, 0.1);
  display: flex;
  align-items: center;
  h6 {
    font-size: $px14;
    letter-spacing: 0.005em;
    color: $white;
    margin-bottom: 0;
    font-weight: 600;
    padding-left: $px2;
  }
  ul {
    margin: 0 auto;
    li {
      a {
        font-size: $px14;
        line-height: $px22;
        letter-spacing: 0.5px;
        color: $white;
        padding: 0 $px6 0 $px10;
      }
      + li {
        border-left: 1px solid rgba(237, 239, 244, 0.1);
      }
    }
  }
  .sub-footer-image {
    svg {
      margin-top: 0.5rem;
    }
  }
}
footer.only-sub-footer .sub-footer {
  margin-top: 0;
  padding: 20px 0;
  border-top: none;
}
@media (max-width: 991px) {
  footer {
    .footer-main {
      [class^='col-'] {
        &:nth-child(4),
        &:last-child {
          padding-top: $px30;
        }
      }
    }
    .sub-footer {
      display: block;
      text-align: center;
      h6 {
        margin-top: -$px6;
      }
      ul {
        padding: $px12 0 $px15;
      }
    }
  }
}
@media (max-width: 767px) {
  footer {
    margin-bottom: $px60;
    .footer-main {
      [class^='col-'] {
        padding-top: 0 !important;
        &:nth-child(2) {
          padding-top: $px30 !important;
        }
        &:last-child {
          .footer-title {
            h5 {
              margin-bottom: 0;
            }
          }
        }
        .footer-social {
          margin-top: $px15;
        }
      }
      .footer-title {
        .according-menu {
          float: right;
          i {
            font-size: $px16;
          }
        }
        &.active {
          ~ .footer-content {
            margin-bottom: $px30;
          }
          ~ .footer-social {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>
